<template>
  <section class="position-avatar">
    <h3 v-if="!insertAvatar">Anna viimane lihv</h3>
    <h4 v-if="!insertAvatar">(Vihje: mobiilis zuumi mugavamaks toimetamiseks veidi sisse)</h4>
    <!-- <button v-if="!insertAvatar" class="button select-none" @click="refreshQuote">
      uus jõulusoov <refresh-icon />
    </button> -->

    <div ref="screenWrapper">
      <div ref="screenshot" class="position-avatar__screenshot" v-resize:throttle="calculateAvatarDimensions">
        <div class="position-avatar__stage" :style="avatarPosition" :class="insertAvatar && '-flash'">
          <img
            ref="avatarClone"
            :src="avatar"
            class="position-avatar__drag -behind"
            :style="{
              width: avatarWidth,
              height: avatarHeight,
              transform: avatarTransform
            }"
          />

          <img
            :src="config.image"
            @load="positionAvatar"
            ref="template"
            class="position-avatar__template select-none"
            :class="templateRatio"
          />
          <img
            ref="avatar"
            :src="avatar"
            class="position-avatar__drag -invisible"
            :class="{
              '-behind': insertAvatar
            }"
          />
          <!-- <p
            class="quote"
            :class="[templateRatio, insertAvatar ? '-squished' : '']"
            :style="`--quote-top-offset:${quotePosition}px;--font:'${quoteFont}'`"
          >
            {{ quote }}
          </p> -->
          <img
            ref="quote"
            :src="quoteImg"
            :style="quoteImgStyles"
            class="position-avatar__quote"
            :class="templateRatio"
          />
        </div>
      </div>
    </div>

    <div class="position-avatar__actions">
      <button class="button select-none" @click="refreshQuote">uus jõulusoov <refresh-icon /></button>
      <button @click="generateImage">valmis <arrow-icon /></button>
    </div>

    <div v-if="insertAvatar" class="screenshot-overlay -flash"></div>

    <img v-if="tmpImg" :src="tmpImg" />
  </section>
</template>

<script>
import Moveable from 'moveable'
import html2canvas from 'html2canvas'
import resize from 'vue-resize-directive'

import { getQuote, getQuoteImg } from '@/quotes'
import ArrowIcon from '@/assets/right-arrow.svg'
import RefreshIcon from '@/assets/refresh.svg'

const wait = ms => new Promise(resolve => setTimeout(resolve, ms))

const cropCanvas = (canvas, x, y, width, height) => {
  const newCanvas = document.createElement('canvas')
  newCanvas.width = width
  newCanvas.height = height
  // draw the canvas in the new resized temp canvas
  newCanvas.getContext('2d').drawImage(canvas, x, y, width, height, 0, 0, width, height)
  return newCanvas
}
const innerDemensions = node => {
  var computedStyle = getComputedStyle(node)

  let height = node.clientHeight
  let width = node.clientWidth
  height -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom)
  width -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight)

  return { height, width }
}

const quoteFonts = ['YearWithoutRain', 'CutItOut', 'LapsusPro', 'MerryChristmas', 'YourStar']
const loadedQuoteFonts = []
const randomFont = () => {
  const randomFont = quoteFonts[Math.floor(Math.random() * quoteFonts.length)]

  if (!loadedQuoteFonts.includes(randomFont)) loadedQuoteFonts.push(randomFont.name)
  return randomFont
}
const quotePositionMap = {
  '-portrait': [50, 30],
  '-landscape': [70, 30],
  '-square': [90, 30]
}

export default {
  name: 'position-avatar',
  directives: { resize },
  data() {
    return {
      tmpImg: '',
      quote: getQuote(),
      quoteImg: getQuoteImg(),
      quotePosition: 600,
      quoteFont: randomFont(),
      avatarCalculated: false,
      avatarTransform: '',
      avatarHeight: '',
      avatarWidth: '',
      // Flag to place avatar behind template
      insertAvatar: false,
      // Flag to add mix-blend-mode while hovering/dragging avatar
      blendAvatar: false,
      moveable: null,
      // Used for drag-resize
      avatarConf: {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        boundHeight: 0,
        boundWidth: 0
      },
      moveableOptions: {
        draggable: true,
        resizable: true,
        rotatable: true,
        pinchable: true,
        keepRatio: true,
        origin: false,
        dragArea: true,
        snappable: true,
        bounds: {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0
        }
      }
    }
  },
  props: {
    avatar: String,
    config: {
      type: Object,
      default: () => ({})
    }
  },
  components: { ArrowIcon, RefreshIcon },
  computed: {
    templateRatio() {
      const templateMap = {
        p: '-portrait',
        l: '-landscape',
        r: '-square'
      }
      const imagePrefix = this.config.image.split('/')[2][0]
      return templateMap[imagePrefix]
    },
    avatarPosition() {
      return Object.entries(this.avatarConf)
        .map(([key, value]) => (key === 'image' ? '' : `--${key}:${value}`))
        .join(';')
    },
    quoteImgStyles() {
      return `--quote-top-offset:${this.quotePosition}px;`
    },
    dragBounds() {
      return Object.entries(this.avatarConf)
        .map(([key, value]) => (key === 'image' ? '' : `--${key}:${value}`))
        .join(';')
    }
  },
  beforeDestroy() {
    this.moveable && this.moveable.destroy()
  },
  methods: {
    async positionAvatar(e) {
      await this.$nextTick()
      await wait(150)
      console.info('positionAvatar()')
      this.calculateAvatarDimensions()
      await this.$nextTick()
      this.avatarCalculated = true
      await this.$nextTick()
      this.initMoveable(e)
      // this.moveable.updateRect()
    },
    async calculateAvatarDimensions() {
      console.info('calculateAvatarDimensions()')
      this.avatarConf.width = Math.floor(this.$refs.screenshot.clientWidth * this.config.size)
      this.avatarConf.height = Math.floor(this.avatarConf.width * 1.4)
      this.avatarConf.left = Math.floor(this.$refs.screenshot.clientWidth * this.config.x)
      this.avatarConf.top = Math.floor(this.$refs.screenshot.clientHeight * this.config.y)
      this.avatarConf.boundHeight = Math.floor(this.avatarConf.height * 1.1)
      this.avatarConf.boundWidth = Math.floor(this.avatarConf.width * 1.1)

      this.moveableOptions.bounds.top = Math.floor(this.avatarConf.top - 70)
      this.moveableOptions.bounds.left = Math.floor(this.avatarConf.left - 60)
      this.moveableOptions.bounds.bottom = Math.floor(this.avatarConf.top + this.avatarConf.height + 100)
      this.moveableOptions.bounds.right = Math.floor(this.avatarConf.left + this.avatarConf.width + 60)

      await this.$nextTick()
      const quotePositionConf = quotePositionMap[this.templateRatio]
      const quotePositionAdjustment =
        document.body.clientWidth / this.$refs.template.clientWidth > 1.2 ? quotePositionConf[0] : quotePositionConf[1]

      this.quotePosition = innerDemensions(this.$refs.template).height + quotePositionAdjustment
      this.moveable && this.moveable.updateRect()
    },
    async initMoveable(e) {
      if (this.insertAvatar) return false

      await this.$nextTick()
      await wait(100)
      console.info('init Moveable with', JSON.stringify(this.moveableOptions))
      this.moveable = new Moveable(this.$refs.screenshot, {
        ...this.moveableOptions,
        target: this.$refs.avatar
      })
      await this.$nextTick()
      await wait(200)
      this.moveable.updateRect()
      this.moveable.dragStart(e)

      /* draggable */
      this.moveable.on('drag', ({ target, transform }) => {
        target.style.transform = transform
        // console.info('transform to apply', transform)
        // console.info('target', target.style, target)
        this.avatarTransform = transform
        // console.info('drag', this.$refs.avatarClone.style, this.$refs.avatarClone)
      })
      /* resizable */
      this.moveable.on('resize', ({ target, width, height, delta }) => {
        if (delta[0]) {
          const newWidth = `${width}px`
          target.style.width = newWidth
          this.$refs.avatarClone.style.width = newWidth
          this.avatarWidth = newWidth
        }
        if (delta[1]) {
          const newHeight = `${height}px`
          target.style.height = newHeight
          this.$refs.avatarClone.style.height = newHeight
          this.avatarHeight = newHeight
        }
      })
      /* pinchable */
      this.moveable.on('pinch', ({ target, transform }) => {
        target.style.transform = transform
        this.avatarTransform = transform
      })
      /* rotatable */
      this.moveable.on('rotate', ({ target, dist, transform }) => {
        if (Math.abs(dist) > 35) return
        target.style.transform = transform
        this.avatarTransform = transform
      })
    },
    refreshQuote() {
      // this.quote = getQuote()
      // this.quoteFont = randomFont()
      window.gtag('event', 'new-wish-text')
      this.quoteImg = getQuoteImg()
    },
    /* eslint-disable no-unreachable */
    async generateImage() {
      this.$emit('camera')
      await wait(200)
      this.moveable.target = null
      // this.moveable.destroy()
      await this.$nextTick()
      this.insertAvatar = true
      window.scrollTo(0, 0)
      await this.$nextTick()
      await wait(1600)

      console.info('Taking screenshot...')
      // const el = this.$refs.screenWrapper
      // const elWidth = el.offsetWidth
      // const elHeight = el.offsetHeight
      const canvas = await html2canvas(this.$refs.screenWrapper, {
        scale: 1,
        useCORS: true,
        removeContainer: false,
        // height: 2000,
        // foreignObjectRendering: true,
        onclone: async () => {
          return new Promise(resolve => {
            setTimeout(() => {
              resolve()
            }, 4000)
          })
        }
      })

      // document.body.clientWidth / this.$refs.template.clientWidth > 1.2
      if (document.body.clientWidth < 960) {
        console.info('returning without cropping sides')
        return canvas.toBlob(blob => {
          this.$emit('submit', {
            name: 'finalImage',
            value: blob
          })
        }, 'image/jpeg')
      }

      // This approach is needed for desktop
      const imageWidth = this.$refs.screenshot.clientWidth
      const imageHeight = this.$refs.screenshot.clientHeight
      const imageStart = (this.$refs.screenWrapper.clientWidth - imageWidth) / 2
      const croppedCanvas = cropCanvas(canvas, imageStart, 0, imageWidth, imageHeight)

      croppedCanvas.toBlob(blob => {
        this.$emit('submit', {
          name: 'finalImage',
          value: blob
        })
      }, 'image/jpeg')
    }
  }
}
</script>

<style lang="scss" src="@/assets/styles/quoteFonts.scss"></style>
<style lang="scss">
.position-avatar {
  margin: 4vh 0 10vh;
  text-align: center;

  h3 {
    font-size: 3rem;
  }
  h4 {
    font-size: 1.25rem;
  }
  .select-none {
    user-select: none;
  }

  &__stage {
    position: relative;
    // display: inline-block;
    display: inline-flex;
    justify-content: center;
    cursor: auto;
    margin: 0 auto;
    z-index: 1;
  }
  &__screenshot {
    display: inline-block;
  }
  &__template {
    position: relative;
    z-index: 5;
    margin-top: 1rem;
    border: 1.75rem solid white;
    box-shadow: inset 0 0 0 3px white;
    align-self: center;
    user-select: none;
    // Template change
    // width: 100%;
    // max-width: 50rem;

    &.-portrait {
      border-top-width: 2.25rem;
      border-left-width: 1.875rem;
      border-bottom-width: 11.5rem;
      border-right-width: 1.875rem;
    }
    &.-square {
      border-top-width: 3.75rem;
      border-left-width: 2.25rem;
      border-bottom-width: 13rem;
      border-right-width: 2.25rem;
    }
    &.-landscape {
      border-top-width: 3.75rem;
      border-left-width: 2.25rem;
      border-bottom-width: 12rem;
      border-right-width: 2.25rem;
    }

    // Template change
    @media screen and (min-width: 46rem) {
      max-height: 80vh;
    }
    @media screen and (max-width: 40rem) {
      &.-portrait {
        border-top-width: 1rem;
        border-left-width: 0.8rem;
        border-bottom-width: 8.375rem;
        border-right-width: 0.8rem;
      }
      &.-square {
        border-top-width: 1.25rem;
        border-left-width: 1rem;
        border-bottom-width: 8.25rem;
        border-right-width: 1rem;
      }
      &.-landscape {
        border-top-width: 1.25rem;
        border-left-width: 1rem;
        border-bottom-width: 8.75rem;
        border-right-width: 1rem;
      }
    }
    @media screen and (max-width: 25rem) {
      &.-square {
        border-bottom-width: 7.25rem;
      }
      &.-landscape {
        border-bottom-width: 7rem;
      }
    }
  }
  &__drag {
    position: absolute;
    cursor: move;
    z-index: 7 !important;
    top: calc(var(--top) * 1px);
    left: calc(var(--left) * 1px);
    width: calc(var(--width) * 1px);

    &.-behind {
      z-index: 1 !important;
    }
    &.-invisible {
      opacity: 0;
    }
  }
  &__actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &__quote {
    position: absolute;
    top: calc(var(--quote-top-offset) + 10px);
    // transition: top 0.1s ease;
    // will-change: top;
    margin: 8px auto 0;
    z-index: 15;
    width: calc(100% - 80px);

    @media screen and (min-width: 70rem) {
      &.-landscape {
        width: calc(100% - 20rem);
      }
      &.-portrait {
        width: calc(100% - 10rem);
      }
      &.-square {
        width: calc(100% - 10rem);
      }
    }
    @media screen and (max-width: 30rem) {
      top: calc(var(--quote-top-offset) + 15px);
    }
  }
  .quote {
    position: absolute;
    top: var(--quote-top-offset);
    transition: top 0.2s ease;
    will-change: top;
    z-index: 5;
    color: #d43021;
    font-size: 2rem;
    left: 15px;
    right: 15px;
    font-weight: 600;
    font-family: var(--font), 'Papyrus', fantasy, cursive;

    &.-squished {
      letter-spacing: 0.7px;
      top: calc(var(--quote-top-offset) - 10px);
    }

    @media screen and (max-width: 70rem) {
      font-size: 1.6rem;
    }
    @media screen and (max-width: 40rem) {
      font-size: 1.4rem;
    }
    @media screen and (max-width: 30rem) {
      font-size: 1.2rem;
    }
  }

  .screenshot-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 0;
  }

  .-flash {
    animation: 0.7s ease-out flash 1;
  }

  // Moveable control buttons
  .moveable-control-box .moveable-control {
    width: 8px;
    height: 8px;
    margin-top: -4px;
    margin-left: -4px;

    &.moveable-s,
    &.moveable-n,
    &.moveable-e,
    &.moveable-w {
      display: none;
    }
  }
}
@keyframes flash {
  from {
    opacity: 1;
  }
  30% {
    opacity: 0.5;
  }
  to {
    opacity: 0;
  }
}
</style>
